import { QuestionsActionConstants } from '../constants';

const questions = (state = [], action) => {
  if (action.type === QuestionsActionConstants.QUESTIONS_RECEIVED) {
    return action.questions;
  }
  return state;
};

export default questions;


// WEBPACK FOOTER //
// ./src/reducers/questions.js